import "./src/styles/global.css"
import "prismjs/themes/prism-tomorrow.css"

// Map of page paths to their script files
const pageScripts = {
  // Draft pages
  "/2021/07/31/nba-draft-2021": "/js/nba-draft-2021.js",
  "/2020/11/14/nba-draft-2020": "/js/nba-draft-2020.js",
  "/2020/04/12/wnba-draft-2020": "/js/wnba-draft-2020.js",
  "/2019/06/16/nba-draft-2019": "/js/nba-draft-2019.js",
  "/2019/04/20/wnba-draft-2019": "/js/wnba-draft-2019.js",
  // RAPM pages
  "/2018/10/05/ncaa-rapm": "/js/ncaa-rapm.js",
  "/2018/10/20/ncaaw-rapm": "/js/ncaaw-rapm.js",
  "/2019/04/27/ncaa-rapm": "/js/ncaa-rapm-2019.js",
  "/2019/05/03/ncaaw-rapm": "/js/ncaaw-rapm-2019.js",
  // Other pages with dropdowns
  "/2020/09/06/empirical-bayes": "/js/empirical-bayes.js",
  "/2019/05/26/estimated-advanced-stats": "/js/estimated-advanced-stats.js",
  "/2019/06/01/rapm-stats": "/js/rapm-stats.js",
  // Shot chart demo page (requires multiple scripts)
  "/2015/02/26/d3-basketball-shot-charts": [
    "/js/d3.v3.min.js",
    "/js/d3-hexbin.js",
    "/js/d3.chart.min.js",
    "/js/d3.chart.defaults.js",
    "/js/d3.basketball-shot-chart.js",
    "/js/d3-shot-charts-demo.js"
  ],
}

// Load Twitter widgets and reinitialize on route changes
// Also load page-specific data scripts
export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined") {
    // Twitter widgets
    if (window.twttr) {
      window.twttr.widgets.load()
    }

    // Check if this page needs a script loaded
    const pathname = location.pathname.replace(/\.html$/, "").replace(/\/$/, "")
    const scriptSrc = pageScripts[pathname]

    if (scriptSrc) {
      // Handle both single scripts and arrays of scripts
      const scripts = Array.isArray(scriptSrc) ? scriptSrc : [scriptSrc]
      const scriptKey = Array.isArray(scriptSrc) ? scriptSrc.join(",") : scriptSrc

      // Check if scripts are already loaded using data attribute
      const existingScript = document.querySelector(`script[data-page-script="${scriptKey}"]`)
      if (!existingScript) {
        // Load scripts sequentially using promises
        const loadScript = (src) => {
          return new Promise((resolve, reject) => {
            const script = document.createElement("script")
            script.src = src
            script.onload = resolve
            script.onerror = reject
            document.head.appendChild(script)
          })
        }

        // Load scripts one after another
        scripts.reduce((promise, src) => {
          return promise.then(() => loadScript(src))
        }, Promise.resolve()).then(() => {
          // Mark as loaded
          const marker = document.createElement("script")
          marker.setAttribute("data-page-script", scriptKey)
          document.head.appendChild(marker)
        }).catch((err) => {
          console.error("Failed to load script:", err)
        })
      }
    }
  }
}

export const onClientEntry = () => {
  if (typeof window !== "undefined" && !window.twttr) {
    const script = document.createElement("script")
    script.src = "https://platform.twitter.com/widgets.js"
    script.async = true
    script.charset = "utf-8"
    document.body.appendChild(script)
  }
}
